import { VisionApplication } from '../../application';
import { GeofenceDrawManager } from '../../map/draw';
import { VisionWindowManager } from '../../window/manager';
import { VisionWindow } from '../../window/window';
import { VisionSpotRockingTab } from './spot_rocking';
import { SpotRockingRegionDTO } from './spot_rocking.service';

export class VisionRegionsWindow extends VisionWindow {
    private layout!: dhtmlXLayoutObject;
    private toolbar!: dhtmlXToolbarObject;
    private form!: dhtmlXForm;
    private grid!: dhtmlXGridObject;

    private drawingManager!: GeofenceDrawManager;

    private map!: google.maps.Map;

    private spotService = VisionApplication.getInstance().spotRockingService;
    private parent: VisionSpotRockingTab;

    constructor(manager: VisionWindowManager, parent: VisionSpotRockingTab) {
        const height = window.innerHeight * 0.75;
        const width = window.innerWidth * 0.75;

        super(manager, {
            id: 'spot_rocking_regions_window',
            title: 'Regiions',
            x: 30,
            y: 30,
            width: width,
            height: height,
        });
        this.parent = parent;
        this.window.setText('Spot Rocking Regions');
        this.modal = false;

        this.buildLayout(width, height);
        this.setupEvents();
    }

    /** Builds the window layout */
    private buildLayout(width: number, height: number): void {
        this.layout = this.window.attachLayout('3W');
        this.layout.cells('a').hideArrow();
        this.layout.cells('a').setText('Regions');
        this.layout.cells('a').setWidth(width * 0.2 - 30);
        this.layout.cells('a').setHeight(height - 30);
        this.layout.cells('a').attachGrid();
        this.grid = this.layout.cells('a').attachGrid();
        this.grid.setHeader('Region', '', []);
        this.grid.init();

        this.layout.cells('b').hideArrow();
        this.layout.cells('b').setText('Properties');
        this.layout.cells('b').setWidth(width * 0.3 - 30);
        this.layout.cells('b').setHeight(height - 30);
        this.toolbar = this.layout.cells('b').attachToolbar();

        this.toolbar.addButton('new', 0, 'New', 'css/imgs/new.gif', '');
        this.toolbar.addButton('save', 1, 'Save', 'css/imgs/save.gif', '');
        this.toolbar.addSeparator('sep1', 2);
        this.toolbar.addButton('delete', 3, 'Delete', 'css/imgs/cut.gif', '');

        this.layout.cells('c').hideArrow();
        this.layout.cells('c').setText('Map');
        this.layout.cells('c').setWidth(width * 0.5 - 30);
        this.layout.cells('c').setHeight(height - 30);
        this.map = this.layout.cells('c').attachMap({ center: { lat: 41.96593, lng: -91.67687 }, zoom: 8 });
        this.drawingManager = new GeofenceDrawManager(this.map, undefined);

        const form_data = [
            { type: 'settings', position: 'label-left', labelWidth: 90, inputWidth: 130 },
            { name: 'id', type: 'input', label: 'ID', value: '', inputWidth: '250', offsetLeft: '25', offsetTop: '25', disabled: true },
            { name: 'name', type: 'input', label: 'Name', value: '', inputWidth: '250', offsetLeft: '25', required: false },
        ];
        this.form = this.layout.cells('b').attachForm({});
        this.form.loadStruct(form_data);
        this.refresh();
    }

    /** Sets up all the event handlers */
    private setupEvents(): void {
        this.grid.attachEvent('onRowSelect', (id) => {
            this.eventSelectRegion(id);
        });

        this.toolbar.attachEvent('onClick', (id) => {
            switch (id) {
                case 'new': {
                    this.grid.clearSelection();
                    if (this.drawingManager.geofence) this.drawingManager.geofence.setMap(null);
                    this.drawingManager.setMode('polygon');
                    this.clearForm();
                    break;
                }
                case 'save': {
                    this.saveRegion();
                    break;
                }
                case 'delete': {
                    this.eventDeleteRegion();
                    break;
                }
            }
        });
    }

    /** Clears the form inputs */
    private clearForm(): void {
        this.form.setItemValue('id', '');
        this.form.setItemValue('name', '');
    }

    /** Saves the region */
    private saveRegion(): void {
        const name = this.form.getItemValue('name');
        if (!name || name.trim() === '') {
            dhtmlx.alert({
                title: 'Error Encountered',
                text: 'Region name is required.',
                type: 'alert-error',
            });
            return;
        }
        if (!this.drawingManager.geofence) {
            dhtmlx.alert({
                title: 'Error Encountered',
                text: 'No region drawn on the map.',
                type: 'alert-error',
            });
            return;
        }

        const path = this.drawingManager.geofence
            .getPath()
            .getArray()
            .concat([this.drawingManager.geofence.getPath().getAt(0)]);

        const data: SpotRockingRegionDTO = {
            id: this.form.getItemValue('id'),
            name: name,
            geometry: path,
        };

        this.spotService.saveRegion(data).then((res) => {
            if (res?.ok) {
                if (res.parsedBody) {
                    this.form.setItemValue('id', res.parsedBody.id);
                    dhtmlx.message({ title: 'Region Saved', text: 'Region ' + res.parsedBody.name + ' was saved.', type: 'alert-success' });

                    this.spotService.refreshRegions();
                    this.refresh();
                    this.parent.refresh();
                }
            }
        });
    }

    private refresh(): void {
        this.spotService.fetchRegions().then((regions) => {
            this.grid.clearAll(false);
            regions.forEach((region) => {
                this.grid.addRow(region.id, [region.name, '0'], 0, 0, '', false);
            });
        });
    }

    private eventSelectRegion(id: string): void {
        this.spotService.fetchRegions().then((regions) => {
            const region = regions.find((r) => r.id === id);
            if (region) {
                this.form.setItemValue('id', region.id);
                this.form.setItemValue('name', region.name);

                if (this.drawingManager.geofence) {
                    this.drawingManager.geofence.setMap(null);
                }

                const polygon = new google.maps.Polygon({
                    paths: region.geometry,
                    strokeColor: '#FF0000',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#FF0000',
                    fillOpacity: 0.35,
                    editable: true,
                    draggable: true,
                });
                polygon.setMap(this.map);
                this.drawingManager.geofence = polygon;
                this.drawingManager.setMode('select');

                // Adjust map to fit the polygon
                const bounds = new google.maps.LatLngBounds();
                region.geometry.forEach((latlng) => {
                    bounds.extend(latlng);
                });
                this.map.fitBounds(bounds);
            }
        });
    }

    private eventDeleteRegion(): void {
        const id = this.form.getItemValue('id');
        if (!id || id.trim() === '') {
            dhtmlx.alert({
                title: 'Error Encountered',
                text: 'No region selected to delete.',
                type: 'alert-error',
            });
            return;
        }

        dhtmlx.confirm({
            type: 'confirm-warning',
            title: 'Confirm Delete',
            text: 'This will delete the Spot Rocking Region.',
            callback: (result: boolean) => {
                if (result) {
                    this.spotService.deleteRegion(id).then((res) => {
                        if (res?.ok) {
                            dhtmlx.message({ title: 'Region Deleted', text: 'Region was deleted.', type: 'alert-success' });

                            this.spotService.refreshRegions();
                            this.refresh();
                            this.parent.refresh();
                            this.clearForm();
                            if (this.drawingManager.geofence) {
                                this.drawingManager.geofence.setMap(null);
                            }
                        }
                    });
                }
            },
        });
    }
}
